@if (isVisible) {
  <div class="ag-filter-wrapper single-select-column-filter">
    <div class="ag-filter-body-wrapper ag-set-filter-body-wrapper">
      <div class="ag-filter-body" ref="eCondition1Body">
        <div class="ag-set-filter">
          <div ref="eFilterLoading" class="ag-filter-loading ag-hidden">Loading...</div>
          @if (!suppressInputSearch) {
            <div role="presentation"
              class="ag-mini-filter ag-labeled ag-label-align-left ag-text-field ag-input-field"
              ref="eMiniFilter">
              <div ref="eLabel" class="ag-input-field-label ag-label ag-hidden ag-text-field-label"></div>
              <div ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper"
                role="presentation">
                <input ref="eInput" class="ag-input-field-input ag-text-field-input" type="text" [(ngModel)]="filterText"
                  (ngModelChange)="onFilterTextChange()"
                  aria-label="Search filter values" placeholder="Search..." tabindex="0">
              </div>
            </div>
          }
          @if (filterValues && filterValues.length === 0) {
            <div ref="eFilterNoMatches" class="ag-filter-no-matches">No matches.</div>
          }
          @if (filterValues && filterValues.length > 0) {
            <div ref="eSetFilterList" class="ag-set-filter-list" role="presentation">
              <div class="ag-virtual-list-viewport ag-filter-virtual-list-viewport"
                role="listbox">
                <div class="ag-tab-guard ag-tab-guard-top" role="presentation"></div>
                <div class="ag-virtual-list-container ag-filter-virtual-list-container" ref="eContainer"
                  [ngStyle]="{'height.px': filterValues?.length * 30}">
                  @for (item of filterValues; track item; let i = $index) {
                    <div class="ag-virtual-list-item ag-filter-virtual-list-item"
                      role="option"
                      [attr.aria-setsize]="filterValues.length" [attr.aria-posinset]="i+1"
                      [tabindex]="i+1"
                      [ngClass]="{'selected-item': item.value === getModel()?.value}"
                      [ngStyle]="{'height.px': 30, 'top.px': i*30}"
                      (click)="onSelectItem(item)">
                      <div class="ag-set-filter-item">
                        <div role="presentation" ref="eCheckbox" class="ag-set-filter-item-checkbox ag-labeled ag-label-align-right ag-checkbox ag-input-field">
                          <div ref="eLabel" class="ag-input-field-label ag-label ag-checkbox-label" [title] ="item.label"
                          style="text-overflow: ellipsis;max-width: 200px;overflow: hidden;white-space: nowrap;" >{{item.label}}</div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div class="ag-tab-guard ag-tab-guard-bottom" role="presentation"></div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="ag-filter-apply-panel" ref="eButtonsPanel">
      <button type="button" class="ag-standard-button ag-filter-apply-panel-button"
        ref="resetFilterButton"
        (click)="onClearAction()">Clear
      </button>
    </div>
  </div>
}
